import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';
import { translate } from 'react-i18next';

import { GOOGLE_MAPS_ZOOM, GOOGLE_MAPS_EMBED_API_KEY } from '../../util/constants';
import brandImage from '../../images/brand-logo.png';

const UnitMap = ({ unit, t }) => {
  // Same inputs the backend geocodes with, so the embed resolves the place we
  // already have coordinates for.
  const placeQuery = [unit.address, unit.city]
    .filter(part => part && part.trim())
    .join(', ');

  if (unit.lat == null || unit.lng == null || !placeQuery) {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <div className="unit-image loaded">
          <Image alt={t('common:ariaLabels.brandImage')} src={brandImage} />
        </div>
      </div>
    );
  }

  // `q` must be an address, not coordinates. The embed's "Open in Maps" link
  // is a free-text search, and for raw coordinates Google resolves no real
  // place: it synthesises the search text out of the coordinate rendering, so
  // Maps opens on `61°30'08.9"N 23°46'02.2"E` instead of the unit's address.
  // `center` keeps the view on our own geocoded coordinates even if Google
  // resolves the address to a slightly different spot.
  const mapSrc = 'https://www.google.com/maps/embed/v1/place'
    + `?key=${GOOGLE_MAPS_EMBED_API_KEY}`
    + `&q=${encodeURIComponent(placeQuery)}`
    + `&center=${unit.lat},${unit.lng}`
    + `&zoom=${GOOGLE_MAPS_ZOOM}`;

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <iframe
        title={t('common:ariaLabels.unitMap')}
        className="unit-google-map loaded"
        src={mapSrc}
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
};

UnitMap.propTypes = {
  unit: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired
};

export default translate(() => ['common', 'booking'])(UnitMap);



// WEBPACK FOOTER //
// ./src/containers/UnitMap/UnitMap.jsx